module.exports = __webpack_public_path__ + "static/media/brooks_durnin_ross.81dacebf.gif";